import { Box, Button } from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { AyceVendorCampaign } from 'apis/ayceCampaign';
import { CustomColors } from 'components/common/CustomTheme/CustomTheme';
import { Vendor } from 'models/vendor';
import * as React from 'react';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import AyceOfferAccordion, { AyceAccordionHandlers, AyceOfferResult } from './AyceOfferAccordion';

type VendorAyceCampaignProps = {
    vendor: Vendor;
    vendorCampaign?: AyceVendorCampaign;
    onSubmit: () => void;
};

export interface VendorCampaignHandlers {
    /**
     * returns void if invalid
     */
    submit: () => Promise<{ offers: AyceOfferResult[] } | void>;
    // isModified: () => boolean;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        wrapper: {
            minHeight: '70vh',
        },
        actionBox: {
            float: 'right',
            border: `1px solid ${CustomColors.border}`,
            borderRadius: theme.shape.borderRadius,
        },
        clearfix: {
            '&:after': {
                content: '""',
                display: 'table',
                clear: 'both',
            },
        },
        actionRow: {
            padding: theme.spacing(1),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'end',
            '& > * + *': {
                marginLeft: theme.spacing(1),
            },
        },
    }),
);

function VendorAyceCampaign({ vendor, onSubmit, vendorCampaign }: VendorAyceCampaignProps, ref): React.ReactElement {
    const classes = useStyles();
    const offersRef = useRef<AyceAccordionHandlers>();

    useImperativeHandle(
        ref,
        (): VendorCampaignHandlers => ({
            submit: async () => {
                // add Page Details form
                const [offers] = await Promise.all([offersRef.current?.submit()]);

                if (!offers) return;

                return {
                    offers,
                };
            },
            // isModified: () => {
            //  call both refs
            // },
        }),
    );

    return (
        <Box className={`${classes.wrapper} ${classes.clearfix}`}>
            <Box className={classes.clearfix}>
                <Box className={classes.actionBox}>
                    <Box className={classes.actionRow}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={onSubmit}
                            data-cy="Ayce-Campaign-SaveButton"
                        >
                            Mock Submit
                        </Button>
                    </Box>
                </Box>
            </Box>
            <AyceOfferAccordion
                ref={offersRef}
                vendor={vendor}
                offers={vendorCampaign?.offers}
                campaignStatus={vendorCampaign?.status}
            />
        </Box>
    );
}

export default forwardRef(VendorAyceCampaign);
